import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {YoungViewModel} from '../../../components/young-info/young-info-view-model/YoungViewModel';
import {dateInscription} from '../../../../environments/environment';
import {Destroyed} from '../../directives/destroyed.directive';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {Season} from "../../helper/season.model";
import { MatButtonModule } from '@angular/material/button';
import { InputTextComponent } from '../../form-parts/form-items/input-text/input-text.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-dialog-attestation',
    templateUrl: './dialog-attestation.component.html',
    styleUrls: ['./dialog-attestation.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogContent, NgIf, MatCheckboxModule, InputTextComponent, MatDialogActions, MatButtonModule]
})
export class DialogAttestationComponent extends Destroyed implements OnInit, OnDestroy {
    dialogRef = inject<MatDialogRef<DialogAttestationComponent>>(MatDialogRef);
    private readonly fb = inject(UntypedFormBuilder);


    isMinor: boolean;
    formGroupAttestation: UntypedFormGroup;
    young: YoungViewModel;
    popupValid = false;

    private readonly season = new Season();
    private readonly currentDate = new Date();

    get fAttestation() {
        return this.formGroupAttestation.controls;
    }

    get youngName() {
        return this.young.firstname + ' ' + this.young.lastname;
    }

    get legalResponsibleName() {
        if (this.young?.legalResponsibles?.length > 0) {
            return this.young.legalResponsibles[0].firstname + ' ' + this.young.legalResponsibles[0].lastname;
        }
        return '';
    }

    get currentYear() {
        if (this.currentDate < dateInscription.limitDate) {
            if (this.currentDate.getFullYear() === dateInscription.limitDate.getFullYear()) {
                return (this.currentDate.getFullYear() - 1) + '-' + this.currentDate.getFullYear();
            } else {
                return this.currentDate.getFullYear() + '-' + dateInscription.limitDate.getFullYear();
            }
        } else {
            return this.season.dateStart.getFullYear() + '-' + this.season.dateEnd.getFullYear();
        }
    }

    ngOnInit() {
        this.formGroupAttestation = this.fb.group({
            dateAttestation: new Date(),
            placeAttestation: [null, Validators.required],
            signAttestation: [null, Validators.required]
        });
    }

    validAttestation() {
        if (this.formGroupAttestation.controls.signAttestation.value
            && this.formGroupAttestation.controls.placeAttestation.value
            && this.formGroupAttestation.controls.placeAttestation.value.trim() !== '') {
            this.popupValid = true;
            this.dialogRef.close();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.popupValid) {
            this.dialogRef.close(this.formGroupAttestation.value);
        } else {
            this.dialogRef.close(null);
        }
    }
}
